export default function Help() {
    return (
      <div className="p-4 max-w-2xl mx-auto space-y-4">
        <h1 className="text-2xl font-bold">Help</h1>
        <p className="text-base">
          Welcome to the Help page. Here you'll find information about using this site and its tools.
        </p>
        <div className="p-4 rounded-2xl shadow bg-white space-y-2">
          <h2 className="text-xl font-semibold">AI Editor Status</h2>
          <p className="text-base">
            The AIT Editor (ait editor) is currently a work in progress and not fully functional yet. 
          </p>
        </div>
      </div>
    );
  }
  